"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProposalStatus = void 0;
const react_1 = require("@apollo/client/react");
const proposal_status_mutation_1 = require("../proposal-status.mutation");
const useProposalStatus = () => {
    const [proposalStatus, data] = (0, react_1.useMutation)(proposal_status_mutation_1.PROPOSAL_STATUS);
    return Object.assign({ proposalStatus }, data);
};
exports.useProposalStatus = useProposalStatus;
exports.default = exports.useProposalStatus;
